export default __webpack_public_path__ + "static/media/Bottom_assessment_selected.4608f2e0.svg";